import { AmplitudeFlagKey, convertTimestampToDateNumber, OrganizationCountry } from "@simplyk/common";

import { GetCurrentUserFrontendObject } from "../../../contexts/types";
import { useAmplitudeFeatureFlag } from "../../../hooks/amplitude/useAmplitudeFeatureFlag";

export const useGetNewCopyContributionCanadaTipValue = ({
  organization,
}: {
  organization: NonNullable<GetCurrentUserFrontendObject["currentOrganization"]>;
}) => {
  const organizationCreatedAtDate = organization.createdAtUtc
    ? convertTimestampToDateNumber(organization.createdAtUtc)
    : "undefined";

  return useAmplitudeFeatureFlag({
    flagKey: AmplitudeFlagKey.NewCopyContributionCanadaTip,
    userProperties: {
      donor_organization_country: organization.country,
      donor_organization_creation_date: organizationCreatedAtDate,
    },
    skip: !organization || organization.country !== OrganizationCountry.Canada,
  });
};
